import { PowerUpsContainer } from "../PowerUpsContainer";
import { ReporterWaiting } from "../level-selection/ReporterWaiting";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { ReusableMenuBackground } from "../ReusableMenuBackground";
import { AudioManager, SoundTrack } from "../../AudioManager";
import { MatchManager } from "../../MatchManager";

export class PreMatchLayer extends Phaser.Group {

    public static currentInstance: PreMatchLayer;

    public powerUpsContainer: PowerUpsContainer;
    public playButton: Phaser.Button;
    public levelSelectionButton: Phaser.Button;

    private reporterWaiting: ReporterWaiting;
    private blackLayer: Phaser.Sprite;
    private scaledItemsContainer: Phaser.Group;

    constructor(game: Phaser.Game) {

        super(game, null, "prematch-layer", false);

        PreMatchLayer.currentInstance = this;

        let backgroundImage: Phaser.Image = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "fondo_menus");
        backgroundImage.scale.setTo(1.25, 1.25);
        this.add(backgroundImage);

        this.scaledItemsContainer = new Phaser.Group(this.game);
        this.scaledItemsContainer.y = (1 - GameVars.scaleY) * GameConstants.GAME_HEIGHT * .5;
        this.scaledItemsContainer.scale.y = GameVars.scaleY;
        this.add(this.scaledItemsContainer);

        this.addReusableMenuBackground();
        this.addWaitingAnimation();
        this.addPowerUpsContainer();
        
        this.levelSelectionButton = new Phaser.Button(this.game, 68, 630, "texture_atlas_5", this.onClickLevelSelection, this, 1, 0, 1);
        this.levelSelectionButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on", "exit_button_off");
        this.levelSelectionButton.anchor.set(.5);
        this.scaledItemsContainer.add(this.levelSelectionButton);

        this.playButton = new Phaser.Button(this.game, 686, 630, "texture_atlas_5", this.onClickPlay, this);
        this.playButton.setFrames("play_button_on", "play_button_off", "play_button_on");
        this.playButton.anchor.setTo(.5);
        this.playButton.visible = false;
        this.scaledItemsContainer.add(this.playButton);

        this.playButton.inputEnabled = false;

        this.blackLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.set(12, 16);
        this.add(this.blackLayer);

        this.game.add.tween(this.blackLayer).to({ alpha: 0 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.blackLayer.destroy();
            }, this);
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        PreMatchLayer.currentInstance = null;

        super.destroy(destroyChildren, soft);
    }

    public onFootballSceneInitialized(): void {

        this.playButton.visible = true;

        const pulseTween = this.game.add.tween(this.playButton.scale);
        pulseTween.to({ x: 1.05, y: .95 }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();

        this.playButton.inputEnabled = true;
    }

    private addReusableMenuBackground(): void {

        const reusableMenuBackground = new ReusableMenuBackground(this.game, ReusableMenuBackground.PREMATCH_LAYER);
        this.scaledItemsContainer.add(reusableMenuBackground);
    }

    private addWaitingAnimation(): void {

        this.reporterWaiting = new ReporterWaiting(this.game);
        this.scaledItemsContainer.add(this.reporterWaiting);
    }

    private addPowerUpsContainer(): void {

        this.powerUpsContainer = new PowerUpsContainer(this.game, true);
        this.powerUpsContainer.y = 690;
        this.scaledItemsContainer.add(this.powerUpsContainer);
    }

    private onClickLevelSelection(): void {

        if (GameVars.levelEdition) {
            this.goToScene("DevelopmentLevelSelection");
        } else {
            this.goToScene("TrophyState");
        }

        AudioManager.getInstance().playEffect("play");
    }

    private onClickPlay(): void {

        this.playButton.clearFrames();
        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().stopMusic(SoundTrack.MENUS);
        MatchManager.onMatchStart();
        this.destroy(true);
    }

    private goToScene(nextScene: string): void {

        this.blackLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.setTo(12, 16);
        this.blackLayer.alpha = 0;

        this.game.add.tween(this.blackLayer).to({ alpha: 1 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.game.state.start(nextScene, true, false);
            }, this);
    }
}
